import * as React from 'react';
import { CLOneColPrescriptionSelector } from './CLOneColPrescriptionSelector/CLOneColPrescriptionSelector.js';
import { CLTwoColPrescriptionSelector } from './CLTwoColPrescriptionSelector/CLTwoColPrescriptionSelector.js';
import { NoRangesConfigured } from './components/NoRangesConfigured.js';
import { useContactLensProductData } from '../../../../../context/product-context-hooks.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { isOneColConfigurator } from '../../types/typeguards.js';

const CLPrescriptionSelectorContainer = ()=>{
    const { activeVariant: { prescriptionRanges  } ,  } = useContactLensProductData();
    const { state , triggerToastMessage  } = useCLEcommContext();
    // Get the UI validation state for the prescription columns and checkboxes
    const { columns: { showError: showColumnsError  } , columnCheckboxes: { showError: showCheckboxesError  } , invalidSubmissionsCount ,  } = state.configurator;
    React.useEffect(()=>{
        if (showColumnsError || showCheckboxesError) {
            triggerToastMessage('prescription-form-error');
        }
    }, [
        showColumnsError,
        showCheckboxesError,
        invalidSubmissionsCount
    ]);
    if (!prescriptionRanges || prescriptionRanges.length === 0) {
        return /*#__PURE__*/ React.createElement(NoRangesConfigured, null);
    }
    // TODO:CXRO-1366 - Move the hideRxConfigurator check once the RX toggle is implemented
    if (isOneColConfigurator(state) && state.configurator.hideRxConfigurator) {
        return /*#__PURE__*/ React.createElement(CLOneColPrescriptionSelector, null);
    }
    return /*#__PURE__*/ React.createElement(CLTwoColPrescriptionSelector, {
        prescriptionAttributesSet: prescriptionRanges
    });
};

export { CLPrescriptionSelectorContainer };
//# sourceMappingURL=CLPrescriptionSelectorContainer.js.map
